import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // send httpOnly auth cookie
});

// helper — read named cookie (CSRF cookie is non-HttpOnly so JS can read it)
const readCookie = (name) => {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
};

api.interceptors.request.use((config) => {
  // Auth lives in HttpOnly cookie; no Bearer token in localStorage.
  // Inject active engagement context for multi-tenant scoping
  const engId = localStorage.getItem("csx_active_engagement");
  if (engId) config.headers["X-Engagement-ID"] = engId;
  // Attach CSRF token for state-changing requests when cookie is present
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "delete", "patch"].includes(method)) {
    const csrf = readCookie("csx_csrf");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("csx_token");
      localStorage.removeItem("csx_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
